import React, { useEffect, useState } from "react";
import "./DashBoard.css";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { CiFilter } from "react-icons/ci";
import { FaHandHolding } from "react-icons/fa";
import { RiCheckboxBlankFill } from "react-icons/ri";
import { HiCurrencyDollar } from "react-icons/hi2";
import { AiOutlineDollar } from "react-icons/ai";
import { FaDollarSign } from "react-icons/fa6";
import { Dropdown, Form } from "react-bootstrap";
import DollarIcon from '../../assests/dollarIcon.png';
import { getworkFlowDashBaord, getDoughnutData, getDrgErrorData, getDrgOptimizationData } from "../../api/Service";
import DoughnutChart from "./DoughnutChart";
import FilterModal from "./FilterModal";
import StackedBarChart from "./StackedBarChart";
import axiosInstance from "../../../../../axiosInterceptor";
import { Spinner } from "../../common/Helper";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import { filter } from "lodash";
const DashBaord = ({mode}) => {
  const [selectedAudit, setSelectedAudit] = useState([]);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [auditFiles, setAuditFiles] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [drgErrorData, setDrgErrorData] = useState([{}]);
  const [doughnutData, setDoughnutData] = useState([]);
  const [optimizedRevenue, setOptimizedRevenue] = useState("");
  const [doughnutPercentage, setDoughnutPercentage] = useState();
  const [reviewedChartPercentage, setReviewedCharPercentage] = useState();
  
  const [hasManyFiles,sethasManyFiles] = useState(true);
  const [isFilesLoading,setIsFilesLoading] = useState(false)
  const [currentPage,setCurrentPage] = useState(1) 
  const [loadId, setLoadId] = useState([]);
  const [isDoughnutLoading, setIsDhoughnutLoading] = useState(false);
  const [isErrorRateLoading, setIsErrorRateLoading] = useState(false);

  const [filterOptions, setFilterOptions] = useState({
    headerId: [],
    caseMixSpeciality: [],
    insurerIdentifier: [],
    lengthOfStay: [],
    codedBy: [],
    priorityValue: [],
    selectAllHeaderId:false,
    selectAllCaseMixSpecality:false,
    selectAllInsurerIdentifier:false,
    selectAllCodedBy:false,
    selectAllPriority:false,
  });
  const handleCheckboxChange = (hcpHeaderId, e) => {
    e.stopPropagation();
    console.log(hcpHeaderId)
    const updated = selectedFiles.includes(hcpHeaderId)
      ? selectedFiles.filter(item => item !== hcpHeaderId)
      : [...selectedFiles, hcpHeaderId];
  
    setselectedFiles(updated);
    setFilterOptions(prev => ({
      ...prev,
      headerId: updated,
      selectAllHeaderId: false
    }));
  };
  // const handleCheckboxChange = (hcpHeaderId,e) => {
  //   console.log("clicked",hcpHeaderId)
  //   e.stopPropagation();
  //   setselectedFiles((prev) => {
  //     const updated = prev.includes(hcpHeaderId)
  //       ? prev.filter((item) => item !== hcpHeaderId)
  //       : [...prev, hcpHeaderId];

  //     setFilterOptions((prevFilters) => ({
  //       ...prevFilters,
  //       headerId: updated,
  //       selectAllHeaderId:false
  //     }));
  //      console.log("clicked",updated)
  //     return updated;
  //   });
  //   console.log("clicked",selectedFiles)
  // };

  const handleSelectAll = (e) => {
    e.stopPropagation();
    const shouldSelectAll = !filterOptions.selectAllHeaderId
    const updated = shouldSelectAll?[...selectedFiles]:[]
    setselectedFiles(updated)
    setFilterOptions((prev)=>({...prev,selectAllHeaderId:shouldSelectAll,headerId:updated}))
    
  };
    useEffect(() => {
      if (filterOptions.selectAllHeaderId) {
        setselectedFiles(auditFiles.map((item) => item.hcp_header_id));
      } else {
        setselectedFiles((prev)=>prev);
      }
    }, [auditFiles, filterOptions.selectAllHeaderId]);
  
  const fetchAuditFiles = async (page, load_more) => {
    try {
      setIsFilesLoading(true);
      const response = await getworkFlowDashBaord(page);
      console.log(response,"files resposne");
      console.log(load_more, 'pdpdp')
      if(load_more){
        console.log("updatedFiles",[...auditFiles,...response?.data]);
        setAuditFiles([...auditFiles,...response?.data])
      }
      else{
        setAuditFiles(response?.data);
      }
      sethasManyFiles(true);
      const newPage = page+1;
      setCurrentPage(newPage);
    } catch (error) {
      console.log("Error fetching audit files:", error);
      sethasManyFiles(false)
      if(!load_more){
        setAuditFiles([])
      }
    }
    finally{
      setIsFilesLoading(false);
    }
  };
  useEffect(() => {
    
    fetchAuditFiles(1, true);
    fetchErrorData(filterOptions);
  }, []);

  const fetchDoughnutData = async () => {
    try {
      setIsDhoughnutLoading(true);
      const response = await getDoughnutData(filterOptions);
      setDoughnutData([{ ...response.data }]);
      setIsDhoughnutLoading(false);
    } catch (error) {
      console.log("Error fetching Doughnut Data", error);
    }
  };

  const fetchErrorData = async () => {
    try {
      setIsErrorRateLoading(true);
      const response = await getDrgErrorData(filterOptions);
      setDrgErrorData([response.data]);
      setIsErrorRateLoading(false);
    } catch (error) {
      console.log("Error fetching Drg Error data:", error);
    }
  };

  const fetchDrgOptimizationData = async () => {
    try {
      const response = await getDrgOptimizationData(filterOptions);
      setOptimizedRevenue(response.data.revenue);
    } catch (error) {
      console.log("Error fetching drg optimization data:", error);
    }
  };
  useEffect(()=>{

  },[auditFiles])

  useEffect(() => {
    fetchDoughnutData(filterOptions);
    fetchErrorData(filterOptions);
    fetchDrgOptimizationData(filterOptions);
  }, [filterOptions]);

  const handleSelectChange = (event) => {
    const { value, checked } = event.target;
    let updatedselectedFiles;
    if (!checked) {
      updatedselectedFiles = [...selectedFiles, value];
    } else {
      updatedselectedFiles = selectedFiles.filter((option) => option !== value);
    }
    setselectedFiles(updatedselectedFiles);
    setLoadId(updatedselectedFiles);
  };
 
  return (
    <div className="dashboard-container" style={{width:`${mode==="DARK"?"80%":""}`,margin:"0 auto"}}>
      <div className="sidebar-filter">
      <div className="dashboard-dropdown-container">
  <Dropdown className="dashboard-dropdown">
    <Dropdown.Toggle className="dashboard-dropdown-toggle">
      <CiFilter className="dashboard-dropdown-icon" fontSize={20} />
      <div className="dashboard-dropdown-label" style={{marginLeft:"25px"}}>Select Files</div>
    </Dropdown.Toggle>
    
    <Dropdown.Menu className="dashboard-dropdown-menu">
      <InfiniteScroll
        className="dashboard-dropdown-scroll"
        hasData={hasManyFiles}
        loadMore={() => fetchAuditFiles(currentPage, true)}
        isLoading={isFilesLoading}
      >
        
          <Dropdown.Item 
            as="div" 
            key="select-all" 
            className="dashboard-dropdown-item1" 
            style={{"padding":"4px"}}
            onClick={(e) => handleSelectAll(e) }
          >
          <div className="hcp-card" >
          <Form.Check
              
              type="checkbox"
              className="dashboard-dropdown-checkbox"
              label="Select All"
              checked={filterOptions.selectAllHeaderId}
              onChange={(e) => handleSelectAll(e)}
            />
          </div>

          </Dropdown.Item>
        
        
          {auditFiles.map((item) => (
  <Dropdown.Item 
    as="div" 
    key={item?.hcp_header_id} 
    className="dashboard-dropdown-item1"
    style={{ padding: "4px" }}
    onClick={(e) => e.stopPropagation()}
  >
    <div key={item?.hcp_header_id} className="hcp-card">
      <Form.Check
        key={item?.hcp_header_id}
        id={`checkbox-${item?.hcp_header_id}`}
        type="checkbox"
        value={item?.hcp_header_id}
        checked={selectedFiles.includes(item?.hcp_header_id)}
        onChange={(e) => handleCheckboxChange(item?.hcp_header_id, e)}
      />
      <label
        htmlFor={`checkbox-${item?.hcp_header_id}`}
        className="hcp-card-content"
        style={{
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflowX: "hidden",
        }}
        onClick={(e) => e.stopPropagation()} // Prevent Dropdown.Item click if label clicked
      >
        <div className="card-line date-line">
          {item?.start_date} - {item?.end_date}
        </div>

        <div className="card-line filename-line">
        <span style={{"fontWeight":"500"}}>File:</span> {item.file_name?.join(", ")}
        </div>
        <div className="card-line loadid-line">
          <span style={{"fontWeight":"500","colour":"black"}}>Load ID:</span> {item?.load_id}
        </div>
      </label>
    </div>
  </Dropdown.Item>
))}

      </InfiniteScroll>
    </Dropdown.Menu>
  </Dropdown>
</div>
        <div className="filter-modal">
          <FilterModal  filterOptions={filterOptions} setFilterOptions={setFilterOptions} />
        </div>
      </div>

      <div className="content-area">
        <div className="charts-section">
          <div className="chart-container">
            <div className="chart-image">
              {!isDoughnutLoading ? (
                <DoughnutChart
                  labels={[
                    "Flagged for Review",
                    "Auditing in Progress",
                    "Reviewed No Change",
                    "Reviewed Query Sent",
                    "Reviewed Recoded",
                  ]}
                  values={[
                    doughnutData[0]?.flagged_for_review_count ?? 0,
                    doughnutData[0]?.Auditing_in_progress_count ?? 0,
                    doughnutData[0]?.Reviewed_no_change_count ?? 0,
                    doughnutData[0]?.reviewed_query_sent_count ?? 0,
                    doughnutData[0]?.reviewed_recoded_count ?? 0,
                  ]}
                />
              ) : <Spinner />}
            </div>
          </div>

          <div className="optimization-section">
            <p className="optimization-header">Optimization</p>
            <div className="optimization-details">
              {/* <StackedBarChart data={drgErrorData}/> */}
              {!isErrorRateLoading ? (
                <StackedBarChart data={drgErrorData} />
              ) : (
                <div className="chart-loader">
                  <Spinner />
                </div>
              )}
            </div>
            <div className="stats-box">
              <div className="stats-value">
                <img src={DollarIcon} alt="" style={{ height: "70px" }} />
                <div className="stats-header">Drg Optimization</div>
                <div className="stats-revenue">$ 
  {optimizedRevenue
    ? optimizedRevenue % 1 === 0
      ? optimizedRevenue.toLocaleString('en-US') // No decimals if it's a whole number
      : optimizedRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) // Keep decimals if needed
    : '0'}
</div>
              </div>
              <h6>
                <span className="nwau-label">NWAU </span>
                {optimizedRevenue ? Math.floor((optimizedRevenue / 6465) * 10000) / 10000 : 0}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBaord;